// Generated by CoffeeScript 2.7.0
var SerialNumber;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import FieldList from 'trunks/vue/admin/components/settings/serial_number_fields/fieldable.js';

import SerialNumberBaseModel from 'trunks/vue/admin/components/settings/serial_number_fields/field_model.js';

export default SerialNumber = Vue.extend({
  components: {
    'field-list': FieldList
  },
  template: `<div>
  <div class="switch-box justify-box">
    <label class="switch mt-4">
      <input
        type="checkbox"
        v-model="enabledCustomSerialNumber"
      >
      <span></span>
    </label>
    <span class="switch-text ml-4">
      <div class="black-text">开启编号</div>
      <div class="light-gray-text text-normal mt-2 mb-2">用户发起流程后系统将根据设置好的规则自动生成编号</div>
    </span>
  </div>
  <div class="setting-wrapper">
    <div class="setting-display-container" :class="statusClass">
      <div class="formable-edit-view">
        <field-list
          ref='fieldsView'
          :fieldable='form'
          :fields='form.fields'
          :formFields='formFields'
          @fieldLengthChanged='fieldLengthChangedFunc'
        />
        <button
          class="btn outlined"
          @click="addNewField"
        >
          添加字段
        </button>
        <span class="light-gray-text text-normal ml-3 mr-3">or</span>
        <button
          :disabled="hasNumberType"
          class="btn text-btn"
          @click="addNumberField"
        >
          添加自动计数
        </button>
      </div>
    </div>
  </div>
  <div class="setting-actions justify-between">
    <div class="left"></div>
    <button @click="updateFields">保存</button>
  </div>
</div>`,
  props: {
    formFields: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      hasNumberType: false
    };
  },
  computed: {
    statusClass: function() {
      return {
        'disabled': !this.enabledCustomSerialNumber
      };
    }
  },
  created: function() {
    this.form.fields = this._generateForm(this.fields);
    return this.findNumberType(this.form.fields);
  },
  methods: {
    addNewField: function() {
      return this.$refs.fieldsView.addNewField();
    },
    addNumberField: function() {
      return this.$refs.fieldsView.addNewField('Number');
    },
    fieldLengthChangedFunc: function() {
      var fields, fieldsView;
      fieldsView = this.$refs.fieldsView;
      if (!fieldsView) {
        return;
      }
      fields = fieldsView.fields;
      return this.findNumberType(fields);
    },
    findNumberType: function(fields) {
      var number_type;
      number_type = _.find(fields, (field) => {
        return field.type === 'Number' && !field._destroy;
      });
      return this.hasNumberType = !!number_type;
    },
    updateFields: function() {
      var flow_id;
      flow_id = this.gid.model_id;
      return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${flow_id}`, {
        data: {
          id: flow_id,
          enable_custom_sn: this.enabledCustomSerialNumber,
          serial_number_fields_attributes: this.getData()
        },
        contentType: "application/json; charset=UTF-8",
        success: (form) => {
          this.form.fields = this._generateForm(form.serial_number_fields);
          return newAlertify('保存成功', {
            type: 'success'
          });
        },
        error: function() {
          return newAlertify('保存失败', {
            type: 'error'
          });
        }
      });
    },
    getData: function() {
      var form;
      form = this.form.toJSON();
      return _.map(form.fields_attributes, (field) => {
        if (field.type === 'Number') {
          return {
            ...field,
            type_name: field.type,
            settings: {
              ...field.settings,
              rule: 'sn_count'
            }
          };
        } else {
          return {
            ...field,
            type_name: field.type
          };
        }
      });
    },
    _generateForm: function(fields) {
      var sortedFields;
      sortedFields = _.sortBy(fields, function(field) {
        return field.position;
      });
      return _.map(sortedFields, (field) => {
        return SerialNumberBaseModel.new({
          ...field,
          type: field.type_name,
          settings: {
            ...field.settings,
            form_fields: this.formFields
          }
        }, this.form);
      });
    }
  }
});
